export const CLOUD_FRONT_HEADERS = {
    COUNTRY: 'cloudfront-viewer-country',
} as const
